/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button } from "@nordcloud/gnui";
import { PopoverControls, ACTION } from "~/components";
import { OrganizationUnitChildTableColumns } from "../OrganizationUnitStructure";
import { EditData, SpendTreeItem } from "../types";

type Row = {
  original: SpendTreeItem;
  depth: number;
  isExpanded: boolean;
  subRows: SpendTreeItem[];
};

type Data = {
  row: Row;
  data: SpendTreeItem[];
};

type Props = {
  structureId: string;
  onEditHandler: (data: EditData) => void;
  onAddHandler: (parentNid: string) => void;
  onRemoveHandler: (nid: string, name: string) => void;
};

export const OrganizationUnitsTableColumns = ({
  structureId,
  onEditHandler,
  onAddHandler,
  onRemoveHandler,
}: Props) => {
  return [
    ...OrganizationUnitChildTableColumns(structureId),
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      width: "3rem",
      hasLeftBorder: false,
      Cell: ({ row }: Data) => (
        <PopoverControls
          trigger={
            <Button
              severity="low"
              icon="menu"
              size="md"
              data-testid="orgunit-popover-trigger"
            />
          }
          items={[
            {
              label: "Add child",
              action: ACTION.ADD,
              onClick: () => {
                onAddHandler(row.original.nid);
              },
            },
            {
              label: "Edit",
              action: ACTION.EDIT,
              onClick: () => {
                onEditHandler({
                  nid: row.original.nid,
                  name: row.original.name,
                  parentNid: row.original.parentNid ?? structureId,
                  contactId: row.original.contactPersonId,
                  typeId: row.original.unitId,
                });
              },
            },
            {
              label: "Delete",
              action: ACTION.DELETE,
              onClick: () => {
                onRemoveHandler(row.original.nid, row.original.name);
              },
            },
          ]}
        />
      ),
    },
  ];
};
